var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteOnboarding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2 2.64 2 5.28 2 8 C2.969375 7.236875 3.93875 6.47375 4.9375 5.6875 C5.48277344 5.25824219 6.02804688 4.82898438 6.58984375 4.38671875 C8.27155077 2.94316909 8.27155077 2.94316909 9 0 C9.66 0 10.32 0 11 0 C11.33 0.99 11.66 1.98 12 3 C13.40105576 4.42857119 13.40105576 4.42857119 15.0625 5.6875 C16.031875 6.450625 17.00125 7.21375 18 8 C18 5.36 18 2.72 18 0 C18.66 0 19.32 0 20 0 C20.125 6.75 20.125 6.75 19 9 C18.01 9.33 17.02 9.66 16 10 C15.401875 10.70125 14.80375 11.4025 14.1875 12.125 C12 14 12 14 8.875 13.9375 C6 13 6 13 4 10 C3.01 9.67 2.02 9.34 1 9 C-0.4783226 6.04335481 -0.06032783 3.25770263 0 0 Z ",
    fill: "#ffffff",
    transform: "translate(2,9)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C4.66 2.31 5.32 4.62 6 7 C3.36 7 0.72 7 -2 7 C-1.34 4.69 -0.68 2.38 0 0 Z M1 4 C0.67 4.66 0.34 5.32 0 6 C1.32 5.67 2.64 5.34 4 5 C3.01 4.67 2.02 4.34 1 4 Z ",
    fill: "#ffffff",
    transform: "translate(10,1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C4.33 2.98 4.66 4.96 5 7 C2.69 7 0.38 7 -2 7 C-1.125 2.25 -1.125 2.25 0 0 Z M1 4 C0.67 4.66 0.34 5.32 0 6 C1.32 5.67 2.64 5.34 4 5 C3.01 4.67 2.02 4.34 1 4 Z ",
    fill: "#ffffff",
    transform: "translate(19,1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C4.4606285 2.64738916 5 3.89448334 5 7 C2.69 7 0.38 7 -2 7 C-1.125 1.125 -1.125 1.125 0 0 Z M0 4 C-0.33 4.66 -0.66 5.32 -1 6 C0.32 5.67 1.64 5.34 3 5 C2.01 4.67 1.02 4.34 0 4 Z ",
    fill: "#ffffff",
    transform: "translate(2,1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteOnboarding);
export default __webpack_public_path__ + "static/media/whiteOnboarding.7944e7be3e90742c74f655d61499bd31.svg";
export { ForwardRef as ReactComponent };